import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import profilePhoto from "../../assets/images/Praveen Kumar.png";
import CountUp from "react-countup";
import { FaLinkedin } from "react-icons/fa";

import JSZip from "jszip";
import { saveAs } from "file-saver";

import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const Home = () => {
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const [typingIndex, setTypingIndex] = useState(0);
  const [available, setAvailable] = useState(true);

  const linkedin = 3463;

  const fullText = useMemo(
    () => [
      "Software Developer.",
      "Web Developer.",
      "MERN Stack Developer",
      "Canva Designer.",
      "Freelancer.",
    ],
    []
  );

  // Recruiter Kit
  const handleDownloadKit = async () => {
    const zip = new JSZip();

    const files = [
      { name: "Praveen_Kumar_B.pdf", url: "/recruiter-kit/Praveen_Kumar_B.pdf" },
      { name: "Praveen_Kumar_Projects.pdf", url: "/recruiter-kit/Praveen_Kumar_Projects.pdf" },
      { name: "Contact_Details.pdf", url: "/recruiter-kit/Contact_Details.pdf" },
    ];

    try {
      for (let file of files) {
        const res = await fetch(file.url);
        const blob = await res.blob();
        zip.file(file.name, blob);
      }

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "Praveen_Kumar_Developer_Kit.zip");
    } catch (err) {
      console.error("ZIP error:", err);
    }
  };

  // Typing Effect
  useEffect(() => {
    if (typingIndex < fullText[index].length) {
      const timeout = setTimeout(() => {
        setText((prev) => prev + fullText[index][typingIndex]);
        setTypingIndex(typingIndex + 1);
      }, 100);

      return () => clearTimeout(timeout);
    } else {
      const switchTimeout = setTimeout(() => {
        setText("");
        setTypingIndex(0);
        setIndex((prev) => (prev + 1) % fullText.length);
      }, 2000);

      return () => clearTimeout(switchTimeout);
    }
  }, [index, typingIndex, fullText]);

  // Hire Status
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const ref = doc(db, "settings", "status");
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setAvailable(snap.data().available);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchStatus();
  }, []);

  return (
    <div className="home">
      <div className="home-left">
        <div className={`hire-banner ${available ? "open" : "closed"}`}>
          {available
            ? "🟢 Open to Work — Available for Software Engineer roles, Testing, Technical Support Engineer Roles"
            : "🔴 Not Available — Currently not looking for opportunities"}
        </div>

        <h2 className="hi-text">
          Hi <span className="wave-emoji">👋</span>, I'm{" "}
          <span className="name-text">Praveen Kumar B</span>
        </h2>

        <h3 className="iam-text">
          I am a <span className="typing-text">{text}</span>
        </h3>

        <div className="home-buttons">
          <a
            href="https://drive.google.com/file/d/1IRPkXFylnXo-lI1m4uSddA1n0DNeMntH/view?usp=sharing"
            className="btn multicolor-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Resume
          </a>

          <button className="btn recruiter-btn" onClick={handleDownloadKit}>
            📦 Recruiter Kit
          </button>

          <Link to="/projects" className="btn multicolor-btn">
            Hire Me
          </Link>
        </div>

        <div className="stats">
          <div className="stat">
            <h2>
              <CountUp end={linkedin} duration={2} />+
            </h2>
            <p className="stat-label">
              <FaLinkedin className="icon linkedin" /> LinkedIn Followers
            </p>
          </div>
        </div>
      </div>

      <div className="home-right">
        <img src={profilePhoto} alt="profile" className="profile-photo" />
      </div>
    </div>
  );
};

export default Home;